


























































































































































































import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import Comments, { ResourceType } from "@/store/modules/Comments";
import Viewpoints from "@/store/modules/Viewpoints";
import { Observable, ZenObservable } from "zen-observable-ts";
import { API, graphqlOperation } from "aws-amplify";
import { onCreateThreadComment, onDeleteThreadComment, onUpdateThreadComment } from "@/graphql/subscriptions";
import Colors from "@/utils/Colors";
import Modelling from "@/store/modules/Modelling";
import _ from "lodash";
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { UpdateCommentInput } from "@/API";
import ExportGrowingTable from '@/views/FileExport/ExportGrowingTable.vue';
import ExportFixedTable from '@/views/FileExport/ExportFixedTable.vue';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";

const commentsModule = getModule(Comments)
const choicesModule = getModule(Choices)
const viewpointsModule = getModule(Viewpoints)
const usersModule = getModule(Users);
const modelling = getModule(Modelling);
const decisionsModule = getModule(Decisions)
const workspaceOptions = getModule(WorkspaceOptions)


@Component({
    components: {CardTitle, FactorValueDisplay, ExportGrowingTable, ExportFixedTable}
})
export default class RevisionCommentPanels extends Vue {

    @Prop()
    filteredComments!: Object


    private colors = Colors.COLORS

    @Prop()
    name!: string

    @Prop({required: true})
    decisionId!: string;

    @Prop({required: true})
    showContent!: boolean;

    @Prop({required: true})
    resource!: {
        id: string | 'CONTENT',
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    secondaryResource!: {
        id: string | "WEIGHT",
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    tertiaryResource: {
        id: string,
        name?: string,
        type: ResourceType
    }

    @Prop({default: false, type: Boolean})
    showAllThreads!: boolean

    @Prop({default: false, type: Boolean})
    hover!: boolean

    @Prop()
    clearPanelInc!: number

    @Prop()
    expandPanelInc!: number

    // @Prop({default: false, type: Boolean})
    // show!: boolean

    private createCommentSubscriber: ZenObservable.Subscription[] | null = [];
    private deleteCommentSubscriber: ZenObservable.Subscription[] | null = [];
    private updateCommentSubscriber: ZenObservable.Subscription[] | null = [];

    private newComment = '';
    private filterUsers=[];
    private filterTags=[]
    private replyingToCommentId: string | undefined;
    private loading = true;
    private submittingComment = false;
    private deletingComment = false;
    private showEdit = ""
    private showEditTag = ""
    private show = false;
    private hoverTitle = ""
    private hoverTag = ""
    private tags = ['concerns', 'suggestions', 'strengths', 'questions', 'weaknesses']
    private commentTags = []
    private openPanels = [];
    private revisionView = true;

    @Ref()
    private commentForm: HTMLFormElement;

    get userProfiles() {
        return usersModule.userProfiles;
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    get userId(): string {
        if (this.currentUser) {
            return this.currentUser.userId;
        }
        return '';
    }

    get commentThreads() {
        return commentsModule.commentThreads
    }

    get generatedCommentId() {
        return Comments.generateId(this.resource.id, this.secondaryResource.id, this.tertiaryResource.id);
    }

    get factorResources() {
        return modelling.publishedModelFactorResources
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel
    }

    get choices() {
        return choicesModule.choices;
    }

    get allComments() {
        return Object.values(this.filteredComments).flat()
    }

    private getDisplayName(userId: string) {
        let user;
        if (userId === this.userId) {
            return 'You'
            // user = this.currentUser;
        } else {
            user = this.userProfiles[userId]
        }

        if (!user) {
            return null;
        }

        if (!user.first) {
            return user.email.split('@')[0];
        }

        let name = '';
        if (user.first) {
            name = name + user.first;
        }
        if (user.last) {
            name = name + ' ' + user.last;
        }
        return name;
    }

    private getUserAvatarName(userId: string) {
        let name = this.getDisplayName(userId)
        if (name) {
            return name.substring(0, 1);
        }
    }

     get tagKeyedComments() {
        let tempComments = {}
        // for(let comment of this.allComments) {
        //     if(comment.tags != null) {
        //         comment.tags.map(tag => tempComments[tag].push(comment))
        //     }
        // }
        for(let key of this.commentKeys) {
            let tempObject = {}
            this.allTags.map(tag => {
                let filteredArray = this.filteredComments[key].filter(comment => comment.tags && comment.tags.includes(tag))
                if(filteredArray.length > 0) {
                    Vue.set(tempObject, tag, filteredArray)

                }
                
            })
            if(!_.isEmpty(tempObject)) {
                Vue.set(tempComments, key, tempObject)

            }
        }
        return tempComments
    } 

    private getColor(userId: string) {
        if (userId === this.userId) {
            return 'indigo'
        }
        return this.colors[Object.keys(this.userProfiles).indexOf(userId)]

    }

    async addComment(factorResourceId: string, tag: string) {
        // if (!this.commentForm.validate()) {
        //     return;
        // }

        if (this.newComment.trim().length == 0) {
            return;
        }


        this.submittingComment = true;
        let commentThread = this.commentThreads[Comments.generateId(this.resource.id, this.secondaryResource.id, factorResourceId )]
        let payload ={
            comment: this.newComment,
            decisionId: this.decisionId,
            resourceId: this.resource.id,
            secondaryResourceId: this.secondaryResource.id,
            tertiaryResourceId: factorResourceId,
            threadId: commentThread ? commentThread.id : '',
            tags: [tag]
        }
        //this.allComments[factorResourceId].splice(0, 0, result);
        this.$emit("add", {comment: payload, factorResourceId: factorResourceId})
        this.newComment = '';
        this.commentTags = [];
        this.submittingComment = false;
        this.showEdit = "";
        this.showEditTag = "";

    }

    async updateComment(tag: string, comment: UpdateCommentInput){
        comment.tags.splice(comment.tags.indexOf(tag), 1)
        let result = await commentsModule.updateComment(comment)
    }

    get commentKeys() {
        let keys = Object.keys(this.filteredComments)
        keys = keys.sort((a,b)=> {
            if (a === 'M') {
                return -1;
            }
             if (b === 'M') {
                return 1;
            }
            if(a < b) {
                return -1
            }
            if(a > b) {
                return 1
            }
            if(a === b) {
                return 0
            }

        })
        return keys
    }

    get tagCommentKeys() {
         let keys = Object.keys(this.tagKeyedComments)
        keys = keys.sort((a,b)=> {
            if (a === 'M') {
                return -1;
            }
             if (b === 'M') {
                return 1;
            }
            if(a < b) {
                return -1
            }
            if(a > b) {
                return 1
            }
            if(a === b) {
                return 0
            }

        })
        return keys
    }

    private getNestedKeys(factorId: string) {
        let keys = Object.keys(this.tagKeyedComments[factorId]).sort()
        return keys

    }

    async deleteComment(commentId: string) {
        this.deletingComment = true;
        await commentsModule.deleteComment({id: commentId})
        this.deletingComment = false;
    }


    private formatDate(date: Date) {
        let now = new Date();

        let time = date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});

        let diff = now.getTime() - date.getTime();
        if (diff <= 86400000 && date.getDate() == now.getDate()) {
            return time + ' Today'
        }
        if (diff < (now.getHours() * 3600000) + 86400000) {
            return time + ' Yesterday'
        }
        return date.toDateString()
    }

    private convertStringIndexToNum(value: any) {
        return parseInt(value)
    }

    get factorListTree() {
        return modelling.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptions.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptions.showNonListFactors;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return (
            //     this.contributingVisibility ||
            //     (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            // );
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

    get isViewpointActive() {
        return viewpointsModule.activeViewpointId != null;
    }


    get allTags() {
       let tagList = []
        for(let comment of Object.values(this.allComments).flat()) {
            if(comment.tags && comment.tags.length > 0)
                tagList.push(...comment.tags)
        }
        _.uniq(tagList)
        return tagList
    }

    private removeRowIndex(id: string) {
        if(id.includes('-')) {
            return id.substring(0, id.indexOf('-'))
        }
        else 
            return id
    }

    private formatRowIndex(rowName: string) {
        if(rowName.includes('-')) {
            return parseInt(rowName.substring(rowName.indexOf('-')+1))+1
        } else
            return -10
    }

    private openAllPanels() {
        this.openPanels = Array.from(Array(Object.keys(this.filteredComments).length).keys());
    }

    private closeAllPanels() {
        this.openPanels = []
    }

    @Watch('clearPanelInc') 
    private clearPanelWatch(){
        this.closeAllPanels()
    }

    @Watch('expandPanelInc') 
    private expandPanelIncWatch(){
        this.openAllPanels()
    }


    
}
